<template>
  <section>
    <div class="row">
      <div class="col">
        <p>
          The following are email templates that are used when sending out
          auto-generated emails to your members triggered based upon various
          events. You may wish to change these for your organization.
        </p>
      </div>
    </div>
    <div class="row custom-templates">
      <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
      <div v-show="currentTab === 'Welcome'" class="row">
        <div class="col-md-12 custom-editor">
          <editor
            ref="zEditor3"
            :toolbar="toolbar"
            @message="showMessage"
            @textChange="validateMessage(3)"
            @keyup="saveIt"
          />
          <div class="custom-title">
            <div class="input-group custom-group">
              <span class="input-group-text">tags:</span>
              <select class="form-control" v-model="tag" @change="tagChanged">
                <option
                  v-for="tag of mergetags"
                  :key="tag.id"
                  :value="tag.value"
                >
                  {{ tag.name }}
                </option>
              </select>
              <div class="input-group-text">
                <input
                  v-model="isWelcomeMessage"
                  type="checkbox"
                  class="form-check-input"
                  @click="saveIt"
                />
                <span class="ms-1">turn on?</span>
              </div>
              <span class="ms-2 mt-1">Welcome Message</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="currentTab === 'After Live Class'" class="row">
        <div class="col-md-12 custom-editor">
          <editor
            ref="zEditor1"
            :toolbar="toolbar"
            @message="showMessage"
            @textChange="validateMessage(1)"
            @keyup="saveIt"
          />
          <span class="custom-title">After Live Class</span>
          <!-- <z-textarea
          v-model="liveMessage"
          name="liveMessage"
          label="After Live Class"
        /> -->
        </div>
      </div>
      <div v-show="currentTab === 'Weekly Recap'" class="row">
        <div class="col-md-12 custom-editor">
          <editor
            ref="zEditor2"
            :toolbar="toolbar"
            @message="showMessage"
            @textChange="validateMessage(2)"
            @keyup="saveIt"
          />
          <span class="custom-title">Weekly Recap</span>
          <!-- <z-textarea
          v-model="recapMessage"
          name="recapMessage"
          label="Weekly Recap"
        /> -->
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-md-12">
          <z-message
            v-model="notice"
            :timeout="3000"
            class="alert alert-warning"
          />
        </div>
      </div>
      <!-- <div class="row mt-5">
      <div class="col-md-3">
        <button
          class="btn btn-primary btn-sm"
          :class="{ 'btn-danger': highlightSave }"
          @click="saveEmailTemplates"
        >
          Update Email Templates
        </button>
      </div>
      <div class="col-md-9"></div>
    </div> -->
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZTabs from '@/Components/ZElements/Tabs'
import ZTextarea from '@/Components/ZElements/TextArea'
import Editor from '@/Components/ZElements/Editor.vue'
import ZMessage from '@/Components/ZElements/Message'
export default {
  name: 'organization-emails',
  components: {
    ZTabs,
    ZTextarea,
    Editor,
    ZMessage,
  },
  data() {
    return {
      notice: '',
      highlightSave: false,
      tag: null,
      tabs: ['Welcome', 'After Live Class', 'Weekly Recap'],
      currentTab: 'Welcome',
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ align: [] }],
        ['clean'], // remove formatting button
        ['link', 'image'],
      ],
    }
  },
  mounted() {
    setTimeout(() => {
      this.init()
    }, 200)
  },
  emits: ['valid', 'show', 'saveIt', 'message'],
  computed: {
    ...mapGetters('organizations', ['organization', 'workingText', 'tags']),
    mergetags() {
      let _tags = []
      if (this.tags) {
        _tags = this.tags.filter((x) => x.id !== 0)
      }
      return _tags
    },
    id() {
      let _data = null
      if (this.organization) {
        _data = this.organization.id
      }
      return _data
    },
    liveMessage: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.EmailLiveMessage
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'EmailLiveMessage',
          value: value,
        })
        this.highlightSave = true
      },
    },
    recapMessage: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.EmailRecapMessage
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'EmailRecapMessage',
          value: value,
        })
        this.highlightSave = true
      },
    },
    isWelcomeMessage: {
      get() {
        let _is = true
        if (this.organization) {
          _is = this.organization.isWelcomeMessage === 1 ? true : false
        }
        return _is
      },
      set(value) {
        console.log('set isWelcomeMessage', value)
        if (value === true) {
          value = 1
        } else {
          value = 0
        }
        this.setOrganizationData({
          name: 'IsWelcomeMessage',
          value: value,
        })
        this.highlightSave = true
      },
    },
    welcomeMessage: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.EmailWelcomeMessage
            ? this.organization.EmailWelcomeMessage
            : null
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'EmailWelcomeMessage',
          value: value,
        })
        this.highlightSave = true
      },
    },
  },
  methods: {
    ...mapActions('organizations', ['saveEmails', 'setOrganizationData']),
    init() {
      this.currentTab = 'Welcome'
      this.$emit('message', '')
      this.highlightSave = false
      console.log('Email Templates', {
        live: this.liveMessage,
        recap: this.recapMessage,
        welcome: this.welcomeMessage,
      })
      this.presetMessage(1, this.liveMessage)
      this.presetMessage(2, this.recapMessage)
      this.presetMessage(3, this.welcomeMessage)
      setTimeout(() => {
        this.$emit('saveIt', false)
      }, 200)
    },
    showMessage(msg) {
      this.$emit('message', msg)
    },
    showTab(value) {
      this.currentTab = value
    },
    saveIt() {
      this.$emit('saveIt', true)
    },
    tagChanged() {
      this.$nextTick(() => {
        console.log('Tag Changed', this.tag)
        this.$refs.zEditor3.insertText(this.tag)
        this.tag = null
        this.validate()
      })
    },
    presetMessage(id, text) {
      console.log('Presetting Message', text)
      if (id === 1) {
        if (this.$refs.zEditor1) {
          this.$refs.zEditor1.setHTML(text)
        }
      } else if (id === 2) {
        if (this.$refs.zEditor2) {
          this.$refs.zEditor2.setHTML(text)
        }
      } else if (id === 3) {
        if (this.$refs.zEditor3) {
          this.$refs.zEditor3.setHTML(text)
        }
      }
    },
    messageBody(id) {
      let body = ''
      if (id === 1) {
        if (this.$refs.zEditor1) {
          body = this.$refs.zEditor1.getHTML()
          if (body === '' || body === '<p><br></p>') {
            body = ''
          }
        }
      } else if (id === 2) {
        if (this.$refs.zEditor2) {
          body = this.$refs.zEditor2.getHTML()
          if (body === '' || body === '<p><br></p>') {
            body = ''
          }
        }
      } else if (id === 3) {
        if (this.$refs.zEditor3) {
          body = this.$refs.zEditor3.getHTML()
          if (body === '' || body === '<p><br></p>') {
            body = ''
          }
        }
      }
      return body
    },
    validate() {
      let valid = true
      for (let idx = 1; idx <= 3; idx++) {
        valid = this.validateMessage(idx)
        if (!valid) {
          break
        }
      }
    },
    validateMessage(id) {
      this.$emit('message', '')
      let notice = ''
      let valid = true
      let name = ''
      if (id === 1) {
        name = 'EmailLiveMessage'
      } else if (id === 2) {
        name = 'EmailRecapMessage'
      } else if (id === 3) {
        name = 'EmailWelcomeMessage'
      }
      let body = this.messageBody(id)
      if (body.trim() !== '') {
        this.setOrganizationData({
          name: name,
          value: body,
        })
      } else {
        notice = 'Please provide a temple for '
        if (id === 1) {
          notice += 'After Live Class.'
        } else if (id === 2) {
          notice += 'Weekly Recap.'
        } else if (id === 3) {
          notice += 'Welcoming Message.'
        }
      }
      console.log('Email Templates valid', {
        message: name,
        valid: valid,
      })
      this.$emit('valid', valid)
      this.$emit('message', notice)
      return valid
    },
    async saveEmailTemplates() {
      let data = {
        id: this.organization.id,
        EmailLiveMessage: this.organization.EmailLiveMessage,
        EmailRecapMessage: this.organization.EmailRecapMessage,
        EmailWelcomeMessage: this.organization.EmailWelcomeMessage,
        isWelcomeMessage: this.isWelcomeMessage,
      }
      await this.saveEmails(data)
      this.highlightSave = false
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-editor {
  height: 400px;
  position: relative;
}
.custom-title {
  position: absolute;
  right: 25px;
  top: 5px;
  font-size: 1em;
  font-weight: 500;
}
.custom-group {
  position: relative;
  top: -3px;
}
.custom-templates {
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-select {
  margin: 0;
  position: relative;
  height: 32px;
}
</style>
